import React, { useEffect, useState } from "react";
import { FlatList, View, ActivityIndicator } from "react-native";
import Text from "@components/CustomText";
import NoTicketSvg from "@assets/svg/NoTicketSvg";
import colors from "@constants/color";
import t from "@constants/localization";
import TicketCard from "./TicketCard";
import Loader from "../components/CoverLoader";

const PATH = "screens/SupportTree/SupportTickets/TicketsList";

const TicketsList = ({
  tickets,
  onCancelTicket,
  statusEn = "all",
  statusHi,
  handleReloadList = () => {},
  loadmore = () => {},
  fetchMore = false,
}) => {
  return (
    <FlatList
      data={tickets}
      ListFooterComponent={
        fetchMore ? (
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              padding: 20,
              height: 50,
            }}
          >
            <ActivityIndicator color={colors.primary} size="large" />
          </View>
        ) : null
      }
      renderItem={({ item }) => (
        <TicketCard
          ticket={item}
          handleReloadList={handleReloadList}
          onCancelTicket={() =>
            onCancelTicket(item.ticket_id, item.cf_issue_level_1)
          }
        />
      )}
      keyExtractor={(item) => String(item.id)}
      onEndReached={() => {
        loadmore(statusEn);
      }}
      onEndReachedThreshold={0.05}
      ListEmptyComponent={() =>
        statusEn === "all" ? (
          <View style={{ padding: 20 }}>
            <Text style={{ fontSize: 14, textAlign: "center", marginTop: 10 }}>
              {t(`${PATH}/noTicketRaised`)}
            </Text>

            <Text style={{ fontSize: 14, textAlign: "center", marginTop: 10 }}>
              {t(`${PATH}/ifYouWantToRaiseATicket`)}
            </Text>

            <Text style={{ fontSize: 14, textAlign: "center", marginTop: 10 }}>
              {t(`${PATH}/viewYourTicketsHere`)}
            </Text>
          </View>
        ) : (
          <View
            style={{
              // alignSelf: "center",
              marginTop: 50,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <NoTicketSvg />
            <View
              style={{
                alignSelf: "center",
                alignItems: "center",
              }}
            >
              <Text variant="subtitle_14" style={{ marginBottom: 10 }}>
                {t(`${PATH}/yourAnyTicket`, { status: statusHi })}
              </Text>
            </View>
          </View>
        )
      }
    />
  );
};

export default TicketsList;
